<mkt-toast-message toastID="maxDiscountApplied" innerHTML="Se está aplicando el máximo de descuento para tu código"></mkt-toast-message>
<div class="discount-box mb-20">
    <div class="discount-title mt-0">
        ¿Tienes un código de descuento?
    </div>
    <div class="button-within-input mt-10">
        <input class="linterna" type="text" id="enter" [(ngModel)]="discountCode" oninput="this.value = this.value.toUpperCase()" maxLength="8" placeholder="Código de descuento">
        <button class="btn-primary-tbk" [disabled]="!discountCode" type="submit" aria-label="continuar"
            (click)="aplicarDescuento(discountCode)">
            Aplicar
        </button>
        <p *ngIf="errorMessage" class="invalid-code-txt mb-0 mt-1">
            <i class="icon-circle-error"></i><span class="ml-1">{{ errorMessage }}</span>
        </p>
    </div>
    <div *ngIf="appliedDiscountCode" class="badge badge-pill badge-grey mt-15"><i
            class="icon-tag"></i>{{appliedDiscountCode}}
        <button aria-label="Remover Descuento" title="Remover Descuento" type="button" class="close"
            (click)="removerCodigoDescuento()"><i class="icon-circle-close"></i></button>
    </div>
</div>
<hr>